import PropTypes from 'prop-types'
import { connectStats } from 'react-instantsearch-dom'

import { Text } from '@redriverpress/system'

function MaterialsCount({ nbHits }) {
  return (
    <Text fontWeight={600}>
      {Intl.NumberFormat().format(nbHits)} {nbHits === 1 ? 'result' : 'results'}
    </Text>
  )
}

MaterialsCount.propTypes = {
  nbHits: PropTypes.number.isRequired,
}

export default connectStats(MaterialsCount)
